import { z } from 'zod';

export const currencySchema = z.object({
  code: z.string().min(1, 'Le code ne doit pas être vide').max(20, 'Le code ne doit pas dépasser 20 caractères'),
  description: z.string().min(1, 'La description ne doit pas être vide').max(250, 'La description ne doit pas dépasser 250'),
  taux: z.number().refine(
    val => {
      return /^(?:[1-9]?\d|0)(\.\d{1,3})?$/.test(val.toString());
    },
    {
      message: 'Le taux doit étre inférieur à 100 et au maximum 3 décimales',
    }
  ),
});
